import { requireStates } from "util";
import { ConnectComponent2 } from "util";
import View from "./list/view";
import Presenter from "./list/presenter";

const initialStates = [
  {
    name: "app.registration.product",
    url: "/produtos",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    },
    data: {
      navigation: {
        priority: 300,
        name: "Produtos",
        state: "app.registration.product"
      },
      authorization: context =>
        context.user.permissions.includes("manage_sellables")
    }
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/product/index.js